module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTcwNCA3MzZhNjQgNjQgMCAxIDEgMCAxMjggNjQgNjQgMCAwIDEgMC0xMjh6IG0tMzg0IDBhNjQgNjQgMCAxIDEgMCAxMjggNjQgNjQgMCAwIDEgMC0xMjh6IG0zODQtMjg4YTY0IDY0IDAgMSAxIDAgMTI4IDY0IDY0IDAgMCAxIDAtMTI4eiBtLTM4NCAwYTY0IDY0IDAgMSAxIDAgMTI4IDY0IDY0IDAgMCAxIDAtMTI4eiBtMzg0LTI4OGE2NCA2NCAwIDEgMSAwIDEyOCA2NCA2NCAwIDAgMSAwLTEyOHpNMzIwIDE2MGE2NCA2NCAwIDEgMSAwIDEyOCA2NCA2NCAwIDAgMSAwLTEyOHoiIGZpbGw9IiMwIiBwLWlkPSIxMDE2Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Draggable 1-outlined.svg
// module id = ATXx
// module chunks = 74